'use strict';

exports.__esModule = true;
exports.ObjectView = exports.ObjectsView = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _context = require('@prisma-cms/context');

var _context2 = _interopRequireDefault(_context);

var _reactApollo = require('react-apollo');

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _graphql = require('graphql');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Viewer = (_temp2 = _class = function (_Component) {
  _inherits(Viewer, _Component);

  function Viewer() {
    var _temp, _this, _ret;

    _classCallCheck(this, Viewer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Viewer.prototype.componentWillMount = function componentWillMount() {
    // console.log("Viewer this", this);
    var _props = this.props,
        query = _props.query,
        parentQuery = _props.parentQuery,
        ConnectorContext = _props.ConnectorContext,
        fetchPolicy = _props.fetchPolicy;
    var Query = void 0;
    /**
     * queryName используется в фильтрах
     */

    var queryName = void 0;

    if (query) {
      queryName = query;
      var apiQuery = this.context.query[query];
      Query = apiQuery;
    } else if (parentQuery) {
      Query = parentQuery; // Получаем название операции из готового запроса

      queryName = this.getQueryNameFromQuery(parentQuery);
    }

    if (Query) {
      Query = this.extendQuery(Query);
      this.Renderer = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(Query), {
        options: {
          fetchPolicy: fetchPolicy
        }
      })(function (props) {
        var children = props.children,
            other = _objectWithoutProperties(props, ['children']);

        return _react2.default.createElement(ConnectorContext.Consumer, null, function (context) {
          return _react2.default.createElement(ConnectorContext.Provider, {
            value: _extends({}, context, other)
          }, children);
        });
      });
      Object.assign(this.state, {
        queryName: queryName
      });
    }

    _Component.prototype.componentWillMount && _Component.prototype.componentWillMount.call(this);
  };
  /**
   * Расширяем запрос
   */


  Viewer.prototype.extendQuery = function extendQuery(Query) {
    var _this2 = this;

    var schema = this.context.schema; // console.log("Viewer extendQuery schema", schema);

    if (Query && schema) {
      /**
       * Проходим запрос на предмет директив в фрагментах
       */
      var parsedQuery = (0, _graphql.parse)(Query);

      if (parsedQuery && schema) {
        var types = schema.types;
        var definitions = parsedQuery.definitions;

        if (definitions && definitions.length) {
          definitions.reduceRight(function (current, definition) {
            var kind = definition.kind,
                directives = definition.directives,
                _definition$selection = definition.selectionSet.loc,
                start = _definition$selection.start,
                end = _definition$selection.end,
                body = _definition$selection.source.body,
                typeCondition = definition.typeCondition;

            if (kind === "FragmentDefinition" && typeCondition) {
              var needAutoloadFields = directives && directives.find(function (n) {
                return n && n.name && n.name.value === "prismaCmsFragmentAllFields";
              }) ? true : false;

              if (needAutoloadFields) {
                var _kind = typeCondition.kind,
                    type = typeCondition.name.value;
                /**
                 * Если указана автоподгрузка типов и получен тип, то получаем все скалярные поля для этого типа
                 */

                var fragmentSource = body.slice(start, end);

                if (type) {
                  var field = types.find(function (n) {
                    var kind = n.kind,
                        name = n.name;
                    return kind === "OBJECT" && name === type;
                  });

                  if (field) {
                    var fields = field.fields;
                    fields = fields.filter(function (n) {
                      return n && n.name && _this2.isScalar(n) ? true : false;
                    });
                    /**
                     * Если были получены скалярные поля,
                     * добавляем их в запрос
                     */

                    if (fields.length) {
                      var fieldsList = "\n" + fields.map(function (_ref) {
                        var name = _ref.name;
                        return name;
                      }).join("\n") + "\n";
                      var position = end - 1;
                      Query = [Query.slice(0, position), fieldsList, Query.slice(position)].join('');
                    }
                  }
                }
              }
            }

            return current;
          }, []);
        }
      }
    }

    return Query;
  };

  Viewer.prototype.isScalar = function isScalar(field) {
    var _field$type = field.type,
        kind = _field$type.kind,
        ofType = _field$type.ofType;

    if (kind === "SCALAR") {
      return true;
    } else if (kind === "ENUM") {
      return true;
    } else if ((kind === "NON_NULL" || kind === "LIST") && ofType) {
      return this.isScalar({
        type: ofType
      });
    } else {
      return false;
    }
  };

  Viewer.prototype.getQueryNameFromQuery = function getQueryNameFromQuery(query) {
    var parsedSchema = (0, _graphql.parse)(query);

    if (parsedSchema) {
      var definitions = parsedSchema.definitions;

      if (definitions) {
        var OperationDefinition = definitions.find(function (n) {
          return n.kind === "OperationDefinition";
        });

        if (OperationDefinition) {
          var _ref2 = OperationDefinition.name || {},
              value = _ref2.value;

          return value;
        }
      }
    }
  };

  return Viewer;
}(_react.Component), _class.contextType = _context2.default, _temp2);
/**
 * For Objects connector
 */

Viewer.propTypes = process.env.NODE_ENV !== "production" ? {
  query: _propTypes2.default.string,
  parentQuery: _propTypes2.default.string,
  ConnectorContext: _propTypes2.default.object.isRequired,
  fetchPolicy: _propTypes2.default.oneOf(["cache-first", "cache-and-network", "network-only", "cache-only", "no-cache"])
} : {};

var ObjectsView = exports.ObjectsView = function (_Viewer) {
  _inherits(ObjectsView, _Viewer);

  function ObjectsView() {
    _classCallCheck(this, ObjectsView);

    return _possibleConstructorReturn(this, _Viewer.apply(this, arguments));
  }

  ObjectsView.prototype.render = function render() {
    var _props2 = this.props,
        query = _props2.query,
        children = _props2.children,
        first = _props2.first,
        _props2$pagevariable = _props2.pagevariable,
        pageVariable = _props2$pagevariable === undefined ? "page" : _props2$pagevariable,
        ConnectorContext = _props2.ConnectorContext,
        other = _objectWithoutProperties(_props2, ['query', 'children', 'first', 'pagevariable', 'ConnectorContext']);

    var Renderer = this.Renderer;
    var queryName = this.state.queryName;
    var uri = this.context.uri;

    var _uri$query = uri.query(true),
        page = _uri$query[pageVariable];

    page = parseInt(page) || 0;
    var skip = page ? (page - 1) * first : 0; // return "Sdfdsf";

    return _react2.default.createElement(ConnectorContext.Provider, {
      value: {
        query: query,
        queryName: queryName,
        pageVariable: pageVariable
      }
    }, Renderer ? _react2.default.createElement(Renderer, _extends({
      page: page,
      skip: skip,
      first: first
    }, other), children) : children);
  };

  return ObjectsView;
}(Viewer);
/**
 * For Object connector
 */


var ObjectView = exports.ObjectView = function (_Viewer2) {
  _inherits(ObjectView, _Viewer2);

  function ObjectView() {
    _classCallCheck(this, ObjectView);

    return _possibleConstructorReturn(this, _Viewer2.apply(this, arguments));
  }

  ObjectView.prototype.render = function render() {
    var _props3 = this.props,
        query = _props3.query,
        children = _props3.children,
        ConnectorContext = _props3.ConnectorContext,
        other = _objectWithoutProperties(_props3, ['query', 'children', 'ConnectorContext']);

    var Renderer = this.Renderer;
    var queryName = this.state.queryName;
    return _react2.default.createElement(ConnectorContext.Provider, {
      value: {
        query: query,
        queryName: queryName // pageVariable,

      }
    }, Renderer ? _react2.default.createElement(Renderer // page={page}
    // skip={skip}
    // first={first}
    , other, children) : children);
  };

  return ObjectView;
}(Viewer);

exports.default = Viewer;